import styled from 'styled-components';

export const PaginationStyled = styled.div`
  padding: 5px 10px;
  border-top: 1px solid #ccc;
  background-color: var(--p-color-bg-surface-secondary);
  display: flex;
  align-items: center;
  justify-content: space-between;
  .Polaris-Select {
    width: fit-content;
  }
  .wrap-perPage {
    display: flex;
    align-items: center;
  }
  .Polaris-Text--root {
    font-size: var(--p-text-body-sm-font-size);
  }
`;
